/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import Request from './request';
import { ApiPrefixV1, ApiV1Base, ApiPrefix } from 'util/icwUtility';

export const apiGetFileDeletedByProductProfile = (productProfileId) => {
  return Request.call({
    url: `/product/${productProfileId}/files/deleted`,
    method: 'GET',
  });
};

export const apiRestoreFileByProductProfile = (productProfileId, ids = []) => {
  return Request.call({
    url: `/product/${productProfileId}/files/restore`,
    method: 'POST',
    data: {
      fileIds: ids,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiDeletePermanentlyByProductProfile = (productProfileId, ids = []) => {
  return Request.call({
    url: `/product/${productProfileId}/files/delete-permanently`,
    method: 'POST',
    data: {
      fileIds: ids,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiSearchProductFile = (productProfileId, params = {}) => {
  return Request.call({
    url: `/product/${productProfileId}/files/search`,
    params,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiVerifyProductFiles = async (productId, fileId, data = {}) => {
  return Request.call({
    url: `product/${productId}/files/${fileId}/verified`,
    data,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiMoveFiles = async (productId, data = {}) => {
  return Request.call({
    url: `product/${productId}/files`,
    data,
    method: 'PATCH',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiRequestDoC = async (productId, fileIds) => {
  return Request.call({
    url: `product/${productId}/files/request`,
    data: {
      fileIds,
    },
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
